import React from 'react'
import Header from '../../home/Header'
import Footer from '../Footer'
import ReportMisuseForm from './ReportMisuseForm'

export default function index() {
  return (
    <div>
      
        <Header/>
        <ReportMisuseForm/>
        <Footer/>
    </div>
  )
}
